import { useMutation, useQueryClient } from 'react-query';
import axios from "axios";
import { useClientId } from "../context/context.js";

const apiBaseUrl = process.env.REACT_APP_API_URL;

export function useSlots() {
  const clientId = useClientId();
  const queryClient = useQueryClient();

  const retrieveSlotById = async (id) => {
    const { data } = await axios.get(`${apiBaseUrl}/clients/${clientId}/date-slots/${id}`);
    return data;
  };

  const retrieveFullSlotById = async (id) => {
    const { data } = await axios.get(`${apiBaseUrl}/clients/${clientId}/date-slots/${id}/get-full`);
    return data;
  };

  const createSlotRequest = async (slotData) => {
    const { data } = await axios.post(`${apiBaseUrl}/clients/${clientId}/date-slots`, slotData);
    return data;
  };

  const updateSlotRequest = async ({ id, slotData }) => {
    const { data } = await axios.put(`${apiBaseUrl}/clients/${clientId}/date-slots/${id}`, slotData);
    return data;
  };

  const deleteSlotRequest = async (id) => {
    const { data } = await axios.delete(`${apiBaseUrl}/clients/${clientId}/date-slots/${id}`);
    return data;
  };

  const { mutateAsync: updateSlot } = useMutation({
    mutationFn: updateSlotRequest,
    onSuccess: (data) => {
      console.log('Slot updated:', data);
      queryClient.invalidateQueries({ queryKey: ['availability'] });
      queryClient.invalidateQueries({ queryKey: ['adminAvailability'] });
    },
    onError: (error) => console.error("Error updating slot:", error),
  });

  const { mutateAsync: createSlot } = useMutation({
    mutationFn: createSlotRequest,
    onSuccess: (data) => {
      console.log('Slot created:', data);
      queryClient.invalidateQueries({ queryKey: ['availability'] });
      queryClient.invalidateQueries({ queryKey: ['adminAvailability'] });
    },
    onError: (error) => console.error("Error creating slot:", error),
  });

  const { mutateAsync: deleteSlot } = useMutation({
    mutationFn: deleteSlotRequest,
    onSuccess: (data) => {
      console.log('Slot Deleted:', data);
      queryClient.invalidateQueries({ queryKey: ['availability'] });
      queryClient.invalidateQueries({ queryKey: ['adminAvailability'] });
    },
    onError: (error) => console.error("Error deleting slot:", error),
  });

  return {
    retrieveSlotById,
    retrieveFullSlotById,
    updateSlot,
    createSlot,
    deleteSlot
  };
}
